export default "/images/chevrolet.svg?c74e7762b02accbfe3196b7ce4511158";